module.exports = __webpack_public_path__ + "static/media/cross.4f30322e.svg";